import React from 'react';
import './bookreviewpage.styles.css';
import books from '../dataset';
import { PDFViewerComponent } from '../../components/bookViewer/bookViewer.component';
// import ViewWebPage from '../../components/view-web-page/view-web-page.component';


    const BookReviewPage = props => {
  
        const choosedBookId = props.match.params.blink ;
        const choosedBook = books[choosedBookId].booklink ;
        // const choosedBook = books.filter( 
        //   book => ( book.id === choosedBookId )
        // );
        return (
            <div className='container'>
              <h1>مكتبة العنود</h1>
                  {/* <ViewWebPage placelink={choosedBook} /> */}
                  <PDFViewerComponent bookToViewLink={choosedBook}/>
                   <br/>
                  {/* <a className='link-button' href={choosedBook}>Download</a> */}
                  <br/><br/><br/><br/><br/>
            </div>
        );
    };
    export default BookReviewPage
    
        
